<template>
  <div class="container mt80">
    <div class="flexrow_green mb50" >
      <div class="subheader_flex">
        <h1 class="nomargin redhigh">Members</h1>
      </div>
      <div class="flexcircle">
        <router-link to="/newmember"  class="btn btn-vermilion">Add</router-link>
      </div>
    </div>
    <div v-if="orders.length != 0" class="adjust">


     <vue-good-table
    :columns="columns"
    :rows="orders"
    :search-options="{
      enabled: true,
    }"
    :pagination-options="{
      enabled: true,
      perPage: 10,
    }"
    styleClass="vgt-table striped bordered" theme="black-rhino" @on-row-click="onRowClick"/>
</div>
<div v-if="orders.length == 0">
  <p class="text-center">
    No Members Found. Add One
  </p>
</div>
  </div>
</template>
<script>
import moment from 'moment'
  export default {
    name: 'memberlist',
    data () {
      return {
        columns: [
          {
            label: 'Name',
            field: 'username',
            filterOptions: {
              enabled: true,
            },
          },
          {
            label: 'Email',
            field: 'email',
            filterOptions: {
              enabled: true,
            },
          },
          {
            label: 'Created_at',
            field: 'created_at',
            filterOptions: {
              enabled: true,
            },
          }
        ],
        orders: [],
        orderslist: [],
      }
    },
    created () {
      this.loadmembers()
    },
    methods: {
      onRowClick (params) {
    this.$router.push('/member_info/' + params.row.reg_id);

      },
      loadmembers () {
        this.$http.get('/list/memberslist').then((res) => {
          this.orders = res.data.details
          for (var i = 0; i < this.orders.length; i++) {
            this.orders[i].created_at = moment(this.orders[i].created_at).format('DD MMM YYYY')
          }
        })
      }
    }
  }
</script>
<style>
.adjust {
  overflow: scroll;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/memberlist.vue